import isNil from 'lodash/isNil';

/**
 * Builds a URL with query parameters from an object.
 * If the value of a parameter is an array, it is treated as an "explode" parameter
 * and will be serialized as "key=value1&key=value2&...".
 * If the value of a parameter is null or undefined, it will be omitted from the query string.
 * @param {string} baseUrl The base URL to append the query string to.
 * @param {Object} params An object with key-value pairs to serialize into a query string.
 * @returns {string} The URL with query parameters.
 */
export const buildEncodedUrl = (baseUrl, params) => {
  const qs = Object.entries(params)
    .flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        // explode=true format
        return value.map(
          v => `${key}=${encodeURIComponent(v)}`,
        );
      }

      if (isNil(value)) return [];

      return `${key}=${encodeURIComponent(value)}`;
    })
    .join('&');

  return `${baseUrl}?${qs}`;
};